module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09K21SQXM.baeb8129.jpg";